import React, {  Component } from 'react';

export default class RequestProductAndPrice extends Component {
    render() {
        return (
            <div>
				<br /><br />
                <h1 className="pageTitle">GE APPLIANCES PRODUCT/MARKETING CONTENT</h1>
                <h4>GE Appliances’ digitized process gets the latest product information to your systems</h4>
                <blockquote>GE Appliances can proactively keep a customer&#39;s purchasing systems and websites in sync with updated pricing and product information. This electronic transfer of data can be sent to customers on a regularly scheduled basis.</blockquote>
                <h4>The data sent is comprehensive and includes:</h4>
                <blockquote>
                Images, Attributes, Features & Benefits, MSRP, Documents, UPC codes, GTINs, Carton dimensions, and more.
                </blockquote>
                <p>To request product and price content, please send your request details in an e-mail to:<br />
                <a href="mailto:ContentManagementTeam@geappliances.com">ContentManagementTeam@geappliances.com</a></p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/RequestProductAndPrice/index.js